/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/**
 * author: tman
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { FormGroup, ButtonToolbar, ToggleButtonGroup, ToggleButton, HelpBlock } from 'react-bootstrap';
import ItemTitle from '../ItemTitle';
/* eslint-disable jsx-a11y/aria-role */
const CheckboxButton = (props) => {
  const {
    handleCheckboxChange,
    content,
    isShowTC,
    handleCheckboxOnClick
  } = props;
  const questionObj= {
    questionMark: content.questionMark,
    question: content.question,
    questionTip: content.questionTip
  };
  const handleOnChangeAction = (newVal) => {
    handleCheckboxChange(content.questionRel, newVal)
  };
  const questionTitle = (content.question && content.question.title &&content.question.title) || '';
  const errorId = content.checkboxItems[0].dataKey + '0-err';
  const handleOnClick = (event) => {
    content.isDisabled && handleCheckboxOnClick && handleCheckboxOnClick(event, content.questionRel)
  }
  const objTC = content.isDisabled ? { onClick: handleOnClick } : {};
  return (
    <div className="checkbox-box">
      <FormGroup validationState={content.isError ? 'error' : null}>
        { content.question && content.question.title &&
        <ItemTitle content={questionObj} isNeedLabel={false} />
        }
        <ButtonToolbar>
          <ToggleButtonGroup
            onChange={ handleOnChangeAction }
            type="checkbox"
            name={ content.checkboxName }
            //defaultValue={ content.defaultValue }
            value={content.defaultValue}
            className={content.isDisabled ? "checkbox-decoration tc-disabled" : "checkbox-decoration" }
            role={'group'} //group
            aria-label={questionTitle || 'questionTitle'}//A string value marks the current element.
          >
            { content.checkboxItems.map((item, i) =>
              <ToggleButton
                data-key={ item.dataKey }
                data-index={ item.dataIndex }
                key={ i }
                disabled={ content.isDisabled }
                value={ item.value }
                aria-label={ content.ariaLabel || questionTitle+' '+(item.display && item.display) }
                aria-describedby={ `${item.dataKey}${i}-err ${item.dataKey}${i}-tip` }
                {...objTC}
              >
                <i className="before-icon"></i>
                { isShowTC ? 
                  <FormattedMessage id={item.dataKey}
                    defaultMessage={item.display}
                    values={{
                      linkOne: <a tabIndex="0" role="linkOne" onClick={event => props.onClickTC(event, content.questionRel, 'one')} data-key="legalContents">{content.linkText[0]}</a>,
                      linkTwo: <a tabIndex="1" role="linkTwo" onClick={event => props.onClickTC(event, content.questionRel, 'two')} data-key="legalContents">{content.linkText[1]}</a>
                    }}
                /> :
                item.display && item.display
                }
                { item.displayTip &&
                  <p className="item-display-tip" id={ `${item.dataKey}${i}-tip` }>{item.displayTip}</p>
                }
              </ToggleButton>
            )}
          </ToggleButtonGroup>
        </ButtonToolbar>
        <HelpBlock id={ errorId }>{ content.errorMessage }</HelpBlock>
      </FormGroup>
    </div>
  )
};
CheckboxButton.propTypes = {
  content: PropTypes.object.isRequired,
  handleCheckboxChange: PropTypes.func,
  isShowTC: PropTypes.bool
};

CheckboxButton.defaultProps = {
  content: {},
  isShowTC: false
};

export default CheckboxButton;


// WEBPACK FOOTER //
// ./src/shared/AOForm/components/CheckboxButton/CheckboxButton.js